/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IUserViewScope extends ng.IScope {
        userId: string;
        user: Wars.Domain.Model.Dtos.UserSearchDto;
    }

    export class UserView implements IDirective {
        public link($scope: ITreeItemLookupScope, element: JQuery, attrs: ng.IAttributes, controller: TreeItemLookupController) { }
        public controller = ['$scope', "userService", UserViewController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/userView.html';
        public restrict: string = "E";

        public scope: any = {
            userId: '=',
        };
    }

    export class UserViewController implements IController {
        
        constructor(
            private $scope: IUserViewScope,
            private userService: services.UserService)
        {
            $scope.$watch("userId", () => {
                if (this.$scope.userId) {
                    this.userService.getUser(this.$scope.userId).then((user) => this.$scope.user = user);
                } else {
                    this.$scope.user = undefined;
                }
            });
        }
    }
}

warsApp.registerDirective('UserView', []);